import { render, staticRenderFns } from "./MemorizeItemInstruction.vue?vue&type=template&id=25774347&scoped=true&"
import script from "./MemorizeItemInstruction.vue?vue&type=script&lang=js&"
export * from "./MemorizeItemInstruction.vue?vue&type=script&lang=js&"
import style0 from "./MemorizeItemInstruction.vue?vue&type=style&index=0&id=25774347&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25774347",
  null
  
)

/* custom blocks */
import block0 from "./MemorizeItemInstruction.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports